import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const AIComposeSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default AIComposeSVG;
